import { render } from "./D3CurationGraph.vue?vue&type=template&id=8e7953f6&scoped=true"
import script from "./D3CurationGraph.vue?vue&type=script&lang=js"
export * from "./D3CurationGraph.vue?vue&type=script&lang=js"

import "./D3CurationGraph.vue?vue&type=style&index=0&id=8e7953f6&scoped=true&lang=css"
import "./D3CurationGraph.vue?vue&type=style&index=1&id=8e7953f6&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7953f6"]])

export default __exports__